import { getZrmLeaseInfo, getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';

import { _nextTrackEvent } from '..';

import type { ZrmClickstreamLease, ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

export const EVENT_IDS = {
  LEARN_MORE: '8243',
  TOTAL_PRICE_MODAL_INTERACTION: '8361',
  REGULATIONS_CTA: '8244',
  OPT_IN_OFF_TO_ON: '8703',
  OPT_IN_ON_TO_OFF: '8704',
} as const;

type SFTmpEventProps = {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser | null;
};

// https://dataportal.zillowgroup.net/event-registry/8243
export const emitLearnMoreEvent = ({
  currentProperty,
  user,
  triggerObject,
  triggerLocation,
}: SFTmpEventProps & { triggerObject: string; triggerLocation: string }) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.LEARN_MORE,
      event_type_version_id: '5',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'learn_more_cta',
      trigger_object_nm: triggerObject,
    },
    semantic: {
      semantic_event_nm: 'open_partner_blog',
      topic_tag_txt: ['costs_and_fees'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8361
export const emitTotalPriceModalInteractionEvent = ({
  user,
  currentProperty,
  lease,
  triggerSource,
  triggerLocation,
}: SFTmpEventProps & { lease?: ZrmClickstreamLease; triggerSource: string; triggerLocation: string }) =>
  _nextTrackEvent.leaseListingUser({
    envelope: {
      event_type_id: EVENT_IDS.TOTAL_PRICE_MODAL_INTERACTION,
      event_type_version_id: '2',
      event_template_id: '177',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: triggerSource,
      trigger_object_nm: 'zrm_costs_and_fees_tmp_modal',
    },
    semantic: {
      semantic_event_nm: 'interact_with_total_price_modal',
      topic_tag_txt: ['close_total_price_modal', 'confirm_total_price'],
    },
    ...getZrmLeaseInfo(lease),
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8244
export const emitRegulationsCTAClickEvent = ({
  currentProperty,
  user,
  triggerObject,
  triggerLocation,
}: {
  user: ZrmClickstreamUser | null;
  currentProperty?: ZrmClickstreamListing;
  triggerObject: string;
  triggerLocation: string;
}) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.REGULATIONS_CTA,
      event_type_version_id: '3',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'fee_transparency_regulations_cta',
      trigger_object_nm: triggerObject,
    },
    semantic: {
      semantic_event_nm: 'open_regulations',
      topic_tag_txt: ['costs_and_fees'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8703
export const emitOptInOffToOnEvent = ({
  currentProperty,
  user,
  triggerLocation,
}: SFTmpEventProps & { triggerLocation: string }) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.OPT_IN_OFF_TO_ON,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'total_price_toggle',
      trigger_object_nm: 'feature_promotion_toggle_generic',
    },
    semantic: {
      semantic_event_nm: 'toggle_total_price',
      topic_tag_txt: ['costs_and_fees'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8704
export const emitOptInOnToOffEvent = ({
  currentProperty,
  user,
  triggerLocation,
}: SFTmpEventProps & { triggerLocation: string }) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.OPT_IN_ON_TO_OFF,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'total_price_toggle',
      trigger_object_nm: 'feature_promotion_toggle_generic',
    },
    semantic: {
      semantic_event_nm: 'toggle_total_price',
      topic_tag_txt: ['costs_and_fees'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });
